// ABOUTME: Chat message component for fulfilment center messages in service desk.
// ABOUTME: Renders messages from warehouse staff aligned to the right with primary color styling.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../theme";
import { getInitials, getTimeAgo } from "../../../../../../utils/servicedesk";
import { support_ticket_activity_action } from "../../../../../../utils/staticEnums";
import MessageTypeText from "./messagetypes/MessageTypeText";
import MessageTypeAttachments from "./messagetypes/MessageTypeAttachments";
import MessageTypeStatusChange from "./messagetypes/MessageTypeStatusChange";
import MessageTypeReassignment from "./messagetypes/MessageTypeReassignment";
import MessageTypeLinkedItem from "./messagetypes/MessageTypeLinkedItem";
import LockIcon from "@mui/icons-material/Lock";


const ChatMessageFulfilmentcenter = ({ group, side = 'right', viewer = 'fulfilmentcenter', isInternal = false }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const timeAgo = getTimeAgo(group.timestamp, t);

    const initials = getInitials(group.senderName);
    const isRight = side === 'right';

    return (
        <Box
            sx={{
                width: 1,
                display: "flex",
                justifyContent: isRight ? 'flex-end' : 'flex-start',
            }}
        >
            <Box
                sx={{
                    width: "60%",
                    display: "flex",
                    flexDirection: isRight ? 'row-reverse' : 'row',
                    gap: 1.5,
                }}
            >
                {/* Avatar */}
                <Box
                    sx={{
                        flexShrink: 0,
                        display: 'flex',
                        background: colors.orange[100],
                        color: colors.orange[400],
                        width: 32,
                        height: 32,
                        borderRadius: 4,
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 14,
                        fontWeight: 700,
                        fontFamily: "Roboto, sans-serif",
                    }}
                >
                    {initials}
                </Box>
                <Box sx={{ flex: 1 }}>
                    {/* Header */}
                    <Box
                        sx={{
                            mt: 0.5,
                            display: "flex",
                            alignItems: "center",
                            flexDirection: isRight ? 'row-reverse' : 'row',
                            gap: 1,
                        }}
                    >
                        <Text semibold>{group.senderName}</Text>
                        {isInternal && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    pl:1,
                                    pr:2,
                                    height: 24,
                                    borderRadius: 3,
                                    background: colors.yellow[100],
                                    color: colors.yellow[400],
                                }}
                            >
                                <LockIcon sx={{ fontSize: 12 }} />
                                <Text fontSize={12} semibold sx={{ color: "inherit" }}>{t("internal_note")}</Text>
                            </Box>
                        )}
                    </Box>
                    {/* Updates */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>

                        {/* <Box
                            // key={updateIndex}
                            sx={{
                                height: 40,
                                borderRadius: 5,
                                background: `linear-gradient(to right, ${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0]} -15%, ${ colors.orange[200]} 150%), ${theme.palette.mode === "dark" ? "black" : "white"}`,
                                border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                                pr: 0.5,
                                pl: 2,
                                display: "flex",
                                alignItems: 'center',
                                justifyContent: "space-between",
                                gap: 1.5,
                            }}
                        >
                            <Text noBreak fontSize={13}>
                                {t("ticket_reassigned_to")}
                            </Text>
                            <Box
                                sx={{
                                    height: 32,
                                    px: 2,
                                    borderRadius: 4,
                                    background: colors.orange[100],
                                    lineHeight: "32px",
                                }}
                            >
                                <Text bold variant="orange">me</Text>
                            </Box>
                        </Box> */}

                        {group.updates.map((update, updateIndex) => {
                            if (update.type === 'text') return <MessageTypeText key={updateIndex} update={update} side={side} isInternal={isInternal} />;
                            if (update.type === 'attachments') return <MessageTypeAttachments key={updateIndex} update={update} />;
                            if (update.type === support_ticket_activity_action.STATUS_CHANGED) return <MessageTypeStatusChange key={updateIndex} update={update} />;
                            if (update.type === support_ticket_activity_action.ASSIGNED || update.type === support_ticket_activity_action.UNASSIGNED) return <MessageTypeReassignment key={updateIndex} update={update} />;
                            if (update.type === support_ticket_activity_action.LINKED_ITEM_ADDED || update.type === support_ticket_activity_action.LINKED_ITEM_REMOVED) return <MessageTypeLinkedItem key={updateIndex} update={update} />;
                            return null;
                        })}
                    </Box>
                    {/* Time ago */}
                    <Box sx={{ mt: 0.5, textAlign: isRight ? 'right' : 'left' }}>
                        <Text fontSize={11} light>{timeAgo}</Text>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default ChatMessageFulfilmentcenter;
